import React, { useState } from "react";
import { Tour } from "../../components/helpers/types/modal_habitacion";
import Spinner from "../../components/helpers/Spinner";
import { formatearNumero } from "../../components/helpers/formatearNumero";
import { usePriceToSelectedCurrency } from "../../hooks/usePriceToSelectedCurrency";
import useCurrencyPrices from "../../hooks/useCurrencyPrices";

interface Props {
    tours: Tour[] | undefined;
    handleClick: (tour: Tour) => void;
    setView: React.Dispatch<React.SetStateAction<string>>;
}

const ModalHabitacionAllTours = ({ tours, handleClick, setView }: Props) => {
    const { SELECTED_CURRENCY } = useCurrencyPrices();
    const { price_to_currency } = usePriceToSelectedCurrency();
    return (
        <div>
            <div
                onClick={() => setView("habitacion")}
                className="flex items-center mx-16 w-60 justify-between text-[#1C4CBB] mt-5 p-4 bg-white rounded-lg shadow-lg gap-5 hover:scale-105 cursor-pointer"
            >
                <div>
                    <svg
                        className="h-8 w-8 text-[#1C4CBB] "
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        {" "}
                        <path stroke="none" d="M0 0h24v24H0z" />{" "}
                        <polyline points="15 6 9 12 15 18" />
                    </svg>
                </div>
                <div>Volver a la reserva</div>
            </div>
            <div className=" grid 2xl:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 grid-cols-1  w-full h-full gap-8 p-4 lg:py-5 lg:px-16">
                {tours?.map((tour, index) => (
                    <div
                        onClick={() => handleClick(tour)}
                        key={`habitacion-${index}`}
                        className={`flex flex-col  items-start border p-4 rounded-lg shadow-lg relative w-[250px] mx-auto cursor-pointer hover:scale-105  `}
                    >
                        <div className=" relative mx-auto w-full ">
                            <img
                                loading="lazy"
                                className=" h-60 w-full rounded-md swiper-lazy object-cover"
                                alt="Imagen del producto"
                                src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hoteles_tours/getImage/${tour.banner}`}
                            />
                        </div>

                        {/* Descripción */}
                        <div
                            className={`  flex flex-col justify-center items-start mt-2 w-full`}
                        >
                            <div className="flex items-center justify-between w-full">
                                <h2 className="text-base font-bold text-[#1C4CBB]">
                                    {tour.nombre}{" "}
                                </h2>
                            </div>

                            <p className="mt-2 text-sm text-gray-600">
                                {tour.descripcion.length > 50
                                    ? `${tour.descripcion.substring(0, 50)}...`
                                    : tour.descripcion}
                            </p>

                            <div className="flex flex-col items-center justify-center w-full mt-3 ">
                                <div className="flex items-center w-max gap-1.5">
                                    <div className="text-sm text-center md:text-base text-[#1C4CBB] ">
                                        {tour.personas} Personas
                                    </div>
                                    <svg
                                        className={`w-6 h-6 2xl:h-8 2xl:w-8 border border-[#1C4CBB] rounded-full`}
                                        id="Capa_2"
                                        data-name="Capa 2"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 62.33 62.33"
                                    >
                                        <g id="Portada">
                                            <g>
                                                <circle
                                                    className="cls-1"
                                                    cx="31.17"
                                                    cy="31.17"
                                                    r="30.67"
                                                    fill="white"
                                                    fillOpacity="100"
                                                />
                                                <g>
                                                    <path
                                                        fill="#1C4CBB"
                                                        className="cls-2"
                                                        d="m39.6,39.12c0,1.02,0,2.05,0,3.07,0,.34-.13.55-.43.71-2.07,1.09-4.27,1.75-6.61,1.95-3.3.28-6.39-.4-9.32-1.91-.35-.18-.52-.4-.51-.82.02-1.91,0-3.82.01-5.74.01-2.29,1.55-4.44,3.7-5.21.23-.08.39-.05.59.1,2.62,1.99,5.67,2,8.27,0,.23-.17.41-.18.66-.08,2.19.86,3.63,2.93,3.64,5.29,0,.88,0,1.75,0,2.63Z"
                                                    />
                                                    <path
                                                        fill="#1C4CBB"
                                                        className="cls-2"
                                                        d="m50.43,36.04c0,.85,0,1.7,0,2.54,0,.32-.13.53-.41.67-1.79.94-3.68,1.49-5.7,1.64-1.14.09-2.25-.01-3.37-.17-.33-.05-.44-.18-.45-.52-.01-1.4.07-2.8-.05-4.2-.17-2.05-1.12-3.65-2.77-4.85-.4-.29-.4-.28-.05-.64.41-.42.88-.75,1.41-1,.2-.1.36-.09.55.07,2.13,1.9,5.43,1.87,7.49,0,.18-.16.34-.17.55-.06,1.75.88,2.71,2.29,2.78,4.26.03.75,0,1.51,0,2.26Z"
                                                    />
                                                    <path
                                                        fill="#1C4CBB"
                                                        className="cls-2"
                                                        d="m11.91,35.81c.05-.84-.13-1.89.1-2.91.34-1.56,1.25-2.68,2.69-3.38.23-.11.39-.08.58.08,2.26,1.88,5.2,1.88,7.43,0,.21-.17.38-.2.61-.08.54.27,1,.62,1.43,1.04.23.23.23.36-.05.56-1.51,1.05-2.44,2.49-2.75,4.3-.14.8-.12,1.61-.12,2.42,0,.79-.01,1.59,0,2.38,0,.3-.1.43-.39.49-3.22.56-6.26.04-9.15-1.48-.27-.14-.38-.35-.38-.65,0-.86,0-1.72,0-2.78Z"
                                                    />
                                                    <path
                                                        fill="#1C4CBB"
                                                        className="cls-2"
                                                        d="m25.49,26.17c0-3.16,2.55-5.7,5.71-5.69,3.15,0,5.67,2.56,5.66,5.74,0,3.12-2.57,5.69-5.69,5.68-3.14,0-5.68-2.57-5.68-5.73Z"
                                                    />
                                                    <path
                                                        fill="#1C4CBB"
                                                        className="cls-2"
                                                        d="m48.16,25.31c0,2.66-2.17,4.83-4.84,4.83-2.62,0-4.81-2.21-4.81-4.83,0-2.63,2.21-4.84,4.85-4.83,2.64,0,4.8,2.18,4.8,4.83Z"
                                                    />
                                                    <path
                                                        fill="#1C4CBB"
                                                        className="cls-2"
                                                        d="m14.18,25.3c0-2.66,2.18-4.83,4.84-4.83,2.62,0,4.81,2.21,4.81,4.83,0,2.64-2.21,4.83-4.86,4.83-2.64,0-4.8-2.18-4.8-4.83Z"
                                                    />
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>

                            <div className="flex flex-col items-center justify-center w-full  ">
                                <div className="flex">
                                    <div className="p-3 md:p-4 sm:px-8 text-base text-center text-[#1C4CBB] align-middle rounded-lg ">
                                        <p className="font-light select-none">
                                            Desde{" "}
                                            <span className="font-semibold">{`${SELECTED_CURRENCY} ${formatearNumero(
                                                price_to_currency(
                                                    Number(tour.precio_base)
                                                )
                                            )} `}</span>{" "}
                                            /por persona
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ModalHabitacionAllTours;
